import React from 'react';
import $ from 'jquery';


function Home() {

  $(document).on('click', '.mobile-nav-toggle', function(e) {
    $('body').toggleClass('mobile-nav-active');
    $('.mobile-nav-toggle i').toggleClass('icofont-navigation-menu icofont-close');
    $('.mobile-nav-overly').toggle();
  });
  
  
    return (
        <div className="home" id="home">
          <button type="button" className="mobile-nav-toggle d-lg-none"><i className="icofont-navigation-menu"></i></button>          
            <header id="header" className="header-tops">
                <div className="container">
                    <h1><a href="#home">Mohamed Awshad</a></h1>
                    <h2>I am a <span>Full Stack Developer</span> from Sri Lanka</h2>

                    {/* Desktop navigation */}
                    <nav  className="nav-menu d-none d-lg-block">                        
                        <ul>
                            <li className="active"><a href="#header">Home</a></li>
                            <li><a href="#about">About</a></li>
                            <li><a href="#resume">Resume</a></li>
                            {/* <li><a href="#services">Services</a></li> */}
                            <li><a href="#portfolio">Projects</a></li>
                            <li><a href="#contact">Contact</a></li>
                        </ul>
                    </nav>

                    {/* Mobile navigation */}
                    <div class="mobile-nav-overly">                        
                        <nav id="navbar" className="mob-nav-menu">                        
                            <ul>
                                <li className="active"><a href="#header">Home</a></li>
                                <li><a href="#about">About</a></li>
                                <li><a href="#resume">Resume</a></li>
                                {/* <li>
                  <a href="#services">Services</a>
                </li> */}
                                <li><a href="#portfolio">Projects</a></li>
                                <li><a href="#contact">Contact</a></li>
                            </ul>
                        </nav>
                    </div>

                    <div className="social-links">
                        <a href="https://twitter.com/Awsha98002666" target="_blank" className="twitter"><i className="icofont-twitter"></i></a>
                        <a href="https://www.facebook.com/mohamed.awsath.7/" target="_blank" className="facebook"><i className="icofont-facebook"></i></a>
                        <a href="https://instagram.com/awshath" target="_blank" className="instagram"><i className="icofont-instagram"></i></a>
                        <a href="https://www.linkedin.com/in/mohamed-awshad-055209178" target="_blank" className="linkedin"><i className="icofont-linkedin"></i></a>
                    </div>
                </div>
            </header>

        </div>
    )
}

export default Home
